const PLATE_NAME_SET = new Set(["创意工美", "科技工美"]);

function readName(item) {
  return item && item.name ? String(item.name).trim() : "";
}

function isPlateName(name) {
  return PLATE_NAME_SET.has(String(name || "").trim());
}

export function normalizeVoteMeta(source = {}) {
  const meta = {
    plateName: source.plateName || "",
    categoryName: source.categoryName || "",
    plateColor: source.plateColor || "",
    categoryColor: source.categoryColor || "",
  };

  if (isPlateName(meta.categoryName) && !isPlateName(meta.plateName)) {
    return {
      plateName: meta.categoryName,
      categoryName: meta.plateName,
      plateColor: meta.categoryColor,
      categoryColor: meta.plateColor,
    };
  }

  return meta;
}

export function normalizeVoteOptionGroups(plateVos = [], categoryVos = []) {
  const normalizedPlateVos = Array.isArray(plateVos) ? plateVos : [];
  const normalizedCategoryVos = Array.isArray(categoryVos) ? categoryVos : [];

  const plateLooksWrong =
    normalizedPlateVos.length > 0 &&
    normalizedPlateVos.some((item) => readName(item) && !isPlateName(readName(item)));
  const categoryLooksLikePlate =
    normalizedCategoryVos.length > 0 &&
    normalizedCategoryVos.some((item) => isPlateName(readName(item)));

  if (plateLooksWrong && categoryLooksLikePlate) {
    return {
      plateVos: normalizedCategoryVos,
      categoryVos: normalizedPlateVos,
    };
  }

  return {
    plateVos: normalizedPlateVos,
    categoryVos: normalizedCategoryVos,
  };
}
